import GeneralButton from "../common/GeneralButton";
import { useNavigate } from "react-router-dom";
import { cleanHTML, cleanHTML2 } from "../utils/commonHelper";

const DetailsComponent = ({ job }) => {
  const navigate = useNavigate();
  if (!job) return null;

  const formattedDate = job.postedDate
    ? new Date(job.postedDate).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "N/A";

  return (
    <div className="grid lg:grid-cols-[3.4fr_1fr] gap-4 lg:gap-10 items-start">
      <div className="bg-[#F7F8F6] rounded-2xl p-6 md:px-10 lg:px-12 lg:py-10 2xl:p-12 2xl:px-20 shadow-sm hover:shadow-md transition-shadow duration-300">
        {/* Job Title */}
        {job.title && (
          <h1 className="text-34pt 1xl:text-36pt  text-secondary mb-2">
            {job.title}
          </h1>
        )}

        {/* Short Description */}
        {job.shortDescription && (
          <p className="text-24pt font-mono text-gray-700  mb-4">
            {job.shortDescription}
          </p>
        )}

        {/* Job Metadata */}
        <div className="flex flex-wrap gap-3 mb-4">
          {job.employmentType && (
            <span className="px-4 py-1.5 text-16pt xl:text-18pt border border-quaternary bg-white font-mono text-quaternary rounded-full text-sm tracking-wide">
              {job.employmentType}
            </span>
          )}
          {job.joiningTime && (
            <span className="px-4 py-1.5 text-16pt xl:text-18pt border border-quaternary bg-white font-mono text-quaternary rounded-full text-sm tracking-wide">
              Joining: {job.joiningTime}
            </span>
          )}
          {job.salary && (
            <span className="px-4 py-1.5 text-16pt xl:text-18pt border border-quaternary bg-white font-mono text-quaternary rounded-full text-sm tracking-wide">
              Salary: {job.salary}
            </span>
          )}
          {job.postedDate && (
            <span className="px-4 py-1.5 text-16pt xl:text-18pt border border-quaternary bg-white font-mono text-quaternary rounded-full text-sm tracking-wide">
              Posted: {formattedDate}
            </span>
          )}
          {/* {job.status && (
            <span
              className={`px-4 py-1.5 rounded-full text-sm tracking-wide ${
                job.status === "1"
                  ? "border border-green text-green"
                  : "border border-secondary text-secondary"
              }`}
            >
              {job.status === "1" ? "Active" : "Inactive"}
            </span>
          )} */}
        </div>

        {/* Divider */}
        <div className="border-t border-gray mt-2 mb-4"></div>

        {/* Job Description */}
        {job.description && (
          <div className="text-gray-800 mb-4 leading-relaxed">
            <h2 className="text-28pt text-secondary mb-3">Job Description</h2>
            <div
              className="terms-container"
              dangerouslySetInnerHTML={{ __html: cleanHTML2(job.description) }}
            />
          </div>
        )}

        {/* CTA Button */}
      </div>
      <div className="bg-secondary rounded-[15px] p-10 1xl:sticky 1xl:top-[180px]">
        <p className="text-24pt 2xl:text-21pt 2.5xl:text-28pt text-white">
          Interested in this job?
        </p>
        <div className="flex justify-start mt-6">
          <GeneralButton
            text="Apply Now"
            type="button"
            title="Click to apply"
            bgColor="#D06F36"
            textColor="#30160E"
            className="text-lg px-4 py-0"
            onClick={() => navigate(`/careers/apply/${job.slug}`)}
          />
        </div>
      </div>
    </div>
  );
};

export default DetailsComponent;
